/* unplugin-vue-components disabled */import { render } from "./PromocodeProcessing.vue?vue&type=template&id=47382b7a&ts=true"
import script from "./PromocodeProcessing.vue?vue&type=script&lang=ts"
export * from "./PromocodeProcessing.vue?vue&type=script&lang=ts"

import "./PromocodeProcessing.vue?vue&type=style&index=0&id=47382b7a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__